// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: '0ac7d612', builtAt: '2026-10-23 21:24 UTC' };
